<template>
	<div>
		<ImageWithCaption
			v-for="(image, index) in images"
			:component="image"
			:key="`image-${index}`"
			class="img"
		/>
	</div>
</template>

<script>
export default defineNuxtComponent({
	name: "ArticleImage",

	props: {
		component: {
			type: Object,
		},
	},

	computed: {
		images() {
			return this.component.content.image.map((image) => {
				return {
					content: {
						image: image.image,
						captionHeader: image.heading,
						captionBody: image.ingress,
					},
				};
			});
		},
	},
});
</script>

<style lang="scss" scoped>
:deep(.figure) {
	display: inline-block;
	padding: $spacing-s;
}

.img :deep(img.responsive-image) {
	width: 100%;
}
</style>
